@if (showCartIcon) {
    <button mat-icon-button [routerLink]="['/cart']" routerLinkActive="router-link-active">
        <mat-icon
            [matBadge]="_cart.length"
            [matBadgeHidden]="_cart.length === 0"
            matBadgeDescription="Charges in cart"
            aria-label="Cart"
            class="md-icon-24"
            aria-hidden="false"
        >
            shopping_cart
        </mat-icon>
    </button>
}
